module.exports = __webpack_public_path__ + "img/injectionsteps_step6.e9e90b66.png";